import React, {FC, ReactElement} from 'react';
import styled from 'styled-components';
import {buttonProps} from './Botton';
import {ButtonElement} from './Botton';
import ElementsClass from '../Elements';

type buttonEditorProps = {}

type EditorProps = buttonProps & buttonEditorProps;


const ButtonEditorElement = styled(ButtonElement)`

`;

const ButtonEditor: FC<EditorProps> = ({...props}): ReactElement => {

    const buttonTitle = '<span>' + props.title + '</span>';
    const buttonDefaultTitle = '<span>Click Here</span>';
    const elementsClass = new ElementsClass();
    let elementObject = elementsClass.getElement('RichText');
    const RichText = elementObject['RichText'];
    const trackStory = props.editorPlugins.trackStory;
    const useAppDispatch = props.editorPlugins.useAppDispatch;
    const dispatch = useAppDispatch();

    function clickEditButtonText() {
        dispatch(trackStory({event:'click button to edit text', screen:'editorv4', params:{}}));
    }

    return (
        <ButtonEditorElement className={'buttonElement'} color={props.color} background={props.background}
                             colorHover={props.colorHover} backgroundHover={props.backgroundHover} round={props.round} fontSize={props.fontSize}
                             horizontalAlignment={props.horizontalAlignment} borderWidth={props.borderWidth} borderColor={props.borderColor} minWidth={props.minWidth} isBold={props.isBold}
                             borderColorHover={props.borderColorHover}>
            <a className={'buttonWrapper'} href={props.url} onClick={() => clickEditButtonText()}>
                <RichText editorPlugins={props.editorPlugins} path={props.path} content={buttonTitle} defaultContent={buttonDefaultTitle} isButton={true}></RichText>
            </a>
        </ButtonEditorElement>
    );
};

// Set default props

export default ButtonEditor;
